package com.starparty.app.astro0

import com.starparty.app.astro0.celestialobjects.DSO
import com.starparty.app.astro0.readers.DSOReader
import com.starparty.app.vector_maths.Matrix4d

/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
class DeepSkyField(time: SP_Time /*, InputStream starsIS, InputStream constellationsIS*/) {
    var dsos: Array<DSO> = arrayOf()
        protected set

    var isShowingDSOs = true

    /** Sets the locations of all the bodies  */
    fun project(transform: Matrix4d) {

        for (d in dsos.indices) {
            dsos[d].setSkyLocation(transform)
        }
    }

    protected fun makeField(time: SP_Time) {
        dsos = DSOReader.makeObjects(time)
        for (d in dsos.indices) {
            addDSO(dsos[d])
        }
    }

    fun addDSO(d: DSO) {
    }

    init {
        makeField(time)
    }
}